// /**
//  * Algolia InstantSearch
//  * InstantSearch hooks for main search results page
//  */

// /**
//  * Style Algolia SearchBox - Run immediately
//  * Apply theme styling to Algolia's search input
//  */
// (function skinAlgoliaSearchBox() {
//   'use strict';

//   const config = window.algoliaThemeConfig || {};

//   const apply = () => {
//     const input = document.querySelector('.main-search .ais-SearchBox-input');

//     if (input) {
//       const hasClass = input.classList.contains('main-search__input');

//       if (!hasClass) {
//         input.classList.add('main-search__input');
//         input.setAttribute(
//           'placeholder',
//           input.getAttribute('placeholder') || config.text?.searchPlaceholder || 'Search...'
//         );
//       }
//     }
//   };

//   // Setup observer when DOM is ready
//   const setupObserver = () => {
//     apply(); // Run once immediately
//     if (document.body) {
//       new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
//     }
//   };

//   // Wait for DOM to be ready
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', setupObserver);
//   } else {
//     setupObserver();
//   }
// })();

// document.addEventListener('algolia.hooks.initialize', function() {
//   'use strict';

//   const config = window.algoliaThemeConfig || {};
//   const utils = window.algoliaUtils || {};
//   const templates = window.algoliaTemplates || {};

//   /**
//    * Add custom widgets
//    * These widgets control UI visibility based on search state
//    * Also configure analytics tags for better tracking
//    */
//   window.algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function() {
//     const widgets = [
//       templates.makeNoResultsToggler?.() || {},
//       // Custom widget to manage "View all" button visibility and helper reference
//       {
//         render({ helper }) {
//           // Store helper reference globally for click handler access
//           window.__algoliaHelper = helper;

//           // Dynamically toggle View all button visibility based on session state
//           const viewAllContainer = document.getElementById('view-all-container');
//           if (viewAllContainer) {
//             viewAllContainer.style.display = window.__algoliaViewAllActive ? 'none' : '';
//           }
//         }
//       },
//       // GTM connector: push Hits Viewed event on every render that has results
//       {
//         render({ results }) {
//           if (!results || !results.hits || results.hits.length === 0) return;
//           window.dataLayer = window.dataLayer || [];
//           window.dataLayer.push({ event: 'Hits Viewed' });
//         }
//       }
//     ];

//     // Add configure widget for analytics tags
//     if (window.algoliaShopify?.externals?.widgets?.configure) {
//       const { configure } = window.algoliaShopify.externals.widgets;

//       // Build analytics tags array
//       const analyticsTags = [];

//       // Determine page type
//       const collection = window.Shopify?.page?.collection;
//       const isSearchPage = window.location.pathname.includes('/search');

//       if (collection) {
//         // Collection page (PLP)
//         analyticsTags.push('page:collection');
//         analyticsTags.push(`collection:${collection.handle}`);
//         config.log?.('Analytics tags - Collection page:', collection.handle);
//       } else if (isSearchPage) {
//         // Main search results page
//         analyticsTags.push('page:search-results');
//         config.log?.('Analytics tags - Search results page');
//       } else {
//         // Fallback
//         analyticsTags.push('page:instantsearch');
//       }

//       // Add device type
//       if (config.isMobile && config.isMobile()) {
//         analyticsTags.push('device:mobile');
//       } else if (window.matchMedia(`(max-width: ${config.breakpoints?.tablet || 1171}px)`).matches) {
//         analyticsTags.push('device:tablet');
//       } else {
//         analyticsTags.push('device:desktop');
//       }

//       // Add user type (logged in vs guest)
//       if (window.Shopify?.customer) {
//         analyticsTags.push('user:logged-in');
//       } else {
//         analyticsTags.push('user:guest');
//       }

//       // Create configure widget with analytics tags and click analytics for GTM
//       const configureOptions = {
//         analyticsTags: analyticsTags,
//         clickAnalytics: true,
//       };

//       const configureWidget = configure(configureOptions);

//       widgets.push(configureWidget);

//       config.log?.('Analytics tags configured:', analyticsTags);
//     }

//     return widgets;
//   });

//   /**
//    * Async function to prefetch best sellers for fallback
//    * Runs before InstantSearch initialization
//    * Only runs on search pages, not collection pages (collections always have results)
//    */
//   window.algoliaShopify.hooks.registerHook('beforeInstantSearchAsyncFunction', async function() {
//     // Skip prefetch on collection pages to avoid extra query
//     const isCollectionPage = window.Shopify?.page?.collection?.handle;
//     if (isCollectionPage) {
//       config.log?.('Skipping best sellers prefetch on collection page');
//       window.__isBestSellersFallback = [];
//       return;
//     }

//     const BEST_SELLERS_COLLECTION_ID = config.collections?.bestSellers || 272070508590;
//     const FALLBACK_LIMIT = config.search?.fallbackLimit || 12;

//     try {
//       const index = window.algoliaShopify.searchClient.initIndex('shopify_products');
//       const { hits } = await index.search('', {
//         hitsPerPage: FALLBACK_LIMIT,
//         filters: `collection_ids:${BEST_SELLERS_COLLECTION_ID}`,
//       });

//       window.__isBestSellersFallback = hits || [];
//       config.log?.('Best sellers prefetched:', hits.length);
//     } catch (e) {
//       config.error?.('Best-sellers prefetch failed:', e);
//       window.__isBestSellersFallback = [];
//     }
//   });

//   /**
//    * No results template with fallback products
//    * Shows best sellers when search returns no results
//    */
//   window.algoliaShopify.hooks.registerHook('beforeInstantSearchNoResultTemplate',
//     function(_defaultTemplate, html) {
//       const hits = window.__isBestSellersFallback || [];

//       config.log?.('No results - showing', hits.length, 'fallback products');

//       return html`
//         <div class="ais-hit-empty">
//           <div class="ais-hit-empty--title">
//             ${window.algoliaShopify?.translations?.noResultFound || 'No results found'}
//           </div>

//           <div class="ais-no-results__fallback">
//             <h3 class="ais-no-results__title">${config.text?.popularInBestSellers || 'Popular in Best sellers'}</h3>
//             <div class="ais-hits-container ais-results-as-block">
//               <div class="ais-Hits">
//                 <ol class="ais-Hits-list">
//                   ${hits.length
//                     ? hits.map((item) => html`
//                         <li class="ais-Hits-item">
//                           ${templates.renderProductCard?.(item, html) || ''}
//                         </li>
//                       `)
//                     : ''}
//                 </ol>
//               </div>
//             </div>
//           </div>
//         </div>
//       `;
//     }
//   );

//   /**
//    * Session-scoped flag to track "View all" state
//    * - Set to true when user clicks "View all" button
//    * - Resets to false on page refresh or navigation
//    * - Used by custom widget to control button visibility
//    */
//   window.__algoliaViewAllActive = false;

//   /**
//    * Main InstantSearch page template
//    * Defines the complete search results page layout
//    */
//   window.algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate',
//     function(_default, data, html) {
//       const collection = window.Shopify?.page?.collection;
//       return html`
//         <div class="ais-page">
//           ${collection ? html`
//             <div class="page-header page-header--with-upper-spacing">
//               <div class="container">
//                 <h1 class="pagetitle h3-style">${collection.title}</h1>
//               </div>
//             </div>
//           ` : ''}
//           <div class="container" style="display: none;">
//             <div class="main-search">
//               <div class="main-search__container container">
//                 <div class="main-search__form" role="search">
//                   <button class="main-search__button button notabutton" type="button" aria-label="Submit">
//                     <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
//                       <g transform="translate(3,3)" stroke="currentColor" stroke-width="1.5" fill="none" fill-rule="evenodd">
//                         <circle cx="7.8235" cy="7.8235" r="7.8235"></circle>
//                         <line x1="13.97" y1="13.97" x2="18.44" y2="18.44" stroke-linecap="square"></line>
//                       </g>
//                     </svg>
//                   </button>
//                   <div class="main-search__input-container">
//                     <div class="ais-input">
//                       <div class="ais-search-box-container"></div>
//                       <div class="ais-input-button"><div class="ais-clear-input-icon"></div></div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div class="ais-search-header">
//             <div class="ais-facets-button-container">
//               <button class="ais-facets-button toggle-btn utility-bar__item" data-toggle-filters>
//                 <span class="button-icon">
//                   <svg width="23" height="19" viewBox="0 0 20 20" stroke-width="1.25" fill="none" xmlns="http://www.w3.org/2000/svg">
//                     <line x1="1" y1="6" x2="19" y2="6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
//                     <line x1="1" y1="14" x2="19" y2="14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
//                     <circle cx="7" cy="6" r="3" fill="none" stroke="currentColor"></circle>
//                     <circle cx="13" cy="14" r="3" fill="none" stroke="currentColor"></circle>
//                   </svg>
//                 </span>
//                 <span>Filter</span>
//                 <span class="toggle-btn__chevron ltr-icon">
//                   <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">
//                     <polyline points="9 18 15 12 9 6"></polyline>
//                   </svg>
//                 </span>
//               </button>
//             </div>
//             <div class="ais-stats-container"></div>
//             <div class="ais-change-display">
//               <span class="ais-change-display-block ais-change-display-selected"><i class="fa fa-th-large"></i></span>
//               <span class="ais-change-display-list"><i class="fa fa-th-list"></i></span>
//             </div>
//             <div class="ais-sort">
//               ${data.multipleSortOrders
//                 ? html`${window.algoliaShopify?.translations?.sortBy || 'Sort by'} <span class="ais-sort-orders-container"></span>`
//                 : html`${window.algoliaShopify?.translations?.sortBy || 'Sort by'} ${window.algoliaShopify?.translations?.relevance || 'Relevance'}`}
//             </div>
//           </div>

//           <div class="ais-facets">
//             <div class="ais-clear-refinements-container"></div>
//             <div class="ais-current-refined-values-container"></div>
//             ${window.algoliaShopify?.config?.app_blocks_dynamic_widgets_beta_enabled
//               ? html`<div class="ais-dynamic-widgets-container"></div>`
//               : data.facets.map(
//                   (facet) => html`
//                     <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}" data-insights-attribute="${facet.name || facet.escapedName}">
//                       <label for="${facet.escapedName}" class="ais-range-slider--header ais-facet--header ais-header">
//                         ${facet.title}
//                       </label>
//                       <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}" name="dropdown" />
//                       <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
//                     </div>
//                   `
//                 )}
//           </div>

//           <div class="ais-hits-block-custom ais-hits-block-custom--full">
//             <div class="ais-block">
//               <div class="ais-hits-container ais-results-as-block"></div>
//             </div>
//           </div>

//           <div class="container pagination-row">
//             <div class="ais-pagination-container"></div>
//           </div>

//           <!-- View all button - visibility controlled by custom widget -->
//           ${collection ? html`
//             <div class="container pagination-row text-center" id="view-all-container">
//               <a href="#" id="view-all" class="button">
//                 View all
//               </a>
//             </div>
//           ` : ''}

//           ${collection && collection.description ? html`
//             <div class="container ais-collection-description">
//               <div class="container container--reading-width fully-spaced-row" dangerouslySetInnerHTML=${{ __html: collection.description }}></div>
//             </div>
//           ` : ''}
//         </div>
//       `;
//     }
//   );

//   /**
//    * Individual product card template for InstantSearch
//    * Uses the shared template from algolia-templates.js
//    */
//   window.algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate',
//     function(_defaultTemplate, hit, html) {
//       return templates.renderProductCard?.(hit, html) || '';
//     }
//   );

//   /**
//    * Facet parameter customization
//    * Customize price slider formatting
//    */
//   window.algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions',
//     function(params, attribute, type) {
//       if (String(attribute.type).toLowerCase() === 'slider' &&
//           String(attribute.name).toLowerCase() === 'price') {

//         const PRICE_IN_CENTS = config.search?.priceInCents || false;

//         const fmt = (v) => {
//           return utils.formatPrice?.(v, PRICE_IN_CENTS) || `$${v}`;
//         };

//         params.tooltips = { format: fmt };
//         params.pips = false;

//         config.log?.('Price slider configured - inCents:', PRICE_IN_CENTS);
//       }

//       return params;
//     }
//   );


//   window.algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate',
//     function(_defaultTemplate, data, html) {
//       return html`
//         ${data.hasOneResult &&
//           html`
//             <span class="ais-stats--nb-results">
//               1 product
//             </span>
//           `}
//         ${data.hasManyResults &&
//           html`
//             <span class="ais-stats--nb-results">
//               ${algoliaShopify.helpers.formatNumber(data.nbHits)} ${' '}
//               products
//             </span>
//           `}
//       `;
//   });

//   /**
//    * Ensure collapsed facets start with checkbox unchecked
//    * Keep color, material, and price expanded by default
//    */
//   function collapseDefaultFacets() {
//     const allCheckboxes = document.querySelectorAll('.ais-facet-dropdown-wrapper input.ais-dropdown-checkbox');

//     // Facets that should stay expanded (matching the logic in the hook)
//     const expandedFacets = ['meta.custom.color_filter', 'meta.custom.material_filter'];

//     allCheckboxes.forEach(function(checkbox) {
//       // The checkbox ID contains the facet name (possibly escaped)
//       const checkboxId = checkbox.id;

//       // Check if this checkbox ID matches any of the expanded facets
//       // Handle both escaped and non-escaped versions
//       const shouldStayExpanded = expandedFacets.some(function(facetName) {
//         // Match the exact name or the escaped version (dots replaced with underscores or kept as-is)
//         return checkboxId === facetName ||
//                checkboxId === facetName.replace(/\./g, '_') ||
//                checkboxId === facetName.replace(/\./g, '-');
//       });

//       // Set checkbox state: expanded facets should be checked, others unchecked
//       checkbox.checked = shouldStayExpanded;

//       // Update wrapper class for chevron animation
//       const wrapper = checkbox.closest('.ais-facet-dropdown-wrapper');
//       if (wrapper) {
//         if (shouldStayExpanded) {
//           wrapper.classList.add('is-expanded');
//         } else {
//           wrapper.classList.remove('is-expanded');
//         }

//         // Add change listener to toggle class when checkbox changes
//         if (!checkbox.dataset.listenerAdded) {
//           checkbox.dataset.listenerAdded = 'true';
//           checkbox.addEventListener('change', function() {
//             // Re-query wrapper to ensure it's current
//             const currentWrapper = checkbox.closest('.ais-facet-dropdown-wrapper');
//             if (currentWrapper) {
//               if (checkbox.checked) {
//                 currentWrapper.classList.add('is-expanded');
//               } else {
//                 currentWrapper.classList.remove('is-expanded');
//               }
//             }
//           });
//         }
//       }
//     });
//   }

//   // Try multiple times to catch when the DOM is ready
//   setTimeout(collapseDefaultFacets, 100);
//   setTimeout(collapseDefaultFacets, 500);
//   setTimeout(collapseDefaultFacets, 1000);

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', collapseDefaultFacets);
//   } else {
//     collapseDefaultFacets();
//   }

//   document.addEventListener('algolia.hooks.afterInstantSearchRender', collapseDefaultFacets);

//   /**
//    * Custom filter toggle functionality
//    * Toggles facets sidebar visibility
//    */
//   function setupCustomFilterToggle() {
//     const toggleButton = document.querySelector('.ais-facets-button[data-toggle-filters]');
//     const facetsPanel = document.querySelector('.ais-page .ais-facets');

//     if (!toggleButton || !facetsPanel) return;

//     // Remove Algolia's click handlers by cloning the button
//     const newButton = toggleButton.cloneNode(true);
//     toggleButton.parentNode.replaceChild(newButton, toggleButton);

//     // Add our custom click handler
//     newButton.addEventListener('click', function(e) {
//       e.preventDefault();
//       e.stopPropagation();

//       const isOpen = facetsPanel.classList.contains('is-open');

//       if (isOpen) {
//         // Hide filters
//         facetsPanel.classList.remove('is-open');
//         newButton.classList.remove('is-active');
//       } else {
//         // Show filters
//         facetsPanel.classList.add('is-open');
//         newButton.classList.add('is-active');
//       }
//     });
//   }

//   // Initialize custom filter toggle - use longer delays to ensure Algolia is done
//   setTimeout(setupCustomFilterToggle, 1000);
//   setTimeout(setupCustomFilterToggle, 2000);
//   document.addEventListener('algolia.hooks.afterInstantSearchRender', setupCustomFilterToggle);

//   /**
//    * Setup scroll buttons functionality
//    * Makes page scroll buttons work on Algolia pages
//    */
//   function setupScrollButtons() {
//     const scrollDown = document.querySelector('.button--page-scroll[data-direction="down"]');
//     const scrollUp = document.querySelector('.button--page-scroll[data-direction="up"]');
//     const footer = document.querySelector("#shopify-section-footer");

//     // Setup scroll down button
//     if (footer && scrollDown) {
//       // Hide button when footer is visible
//       new IntersectionObserver(function(entries) {
//         if (entries[0].isIntersecting) {
//           scrollDown.classList.add('hidden');
//         } else {
//           scrollDown.classList.remove('hidden');
//         }
//       }, {
//         threshold: 0.1
//       }).observe(footer);

//       // Scroll to footer on click
//       if (!scrollDown.dataset.listenerAdded) {
//         scrollDown.dataset.listenerAdded = 'true';
//         scrollDown.addEventListener('click', function() {
//           window.scroll({top: footer.offsetTop, left: 0, behavior: 'smooth'});
//         });
//       }
//     }

//     // Setup scroll up button
//     if (scrollUp && !scrollUp.dataset.listenerAdded) {
//       scrollUp.dataset.listenerAdded = 'true';
//       scrollUp.addEventListener('click', function() {
//         window.scroll({top: 0, left: 0, behavior: 'smooth'});
//       });
//     }
//   }

//   // Initialize scroll buttons
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', setupScrollButtons);
//   } else {
//     setupScrollButtons();
//   }

//   /**
//    * Collection Grid Banner Injection for Algolia
//    * Injects banners into Algolia hits at specified positions
//    * Supports both single banner (object) and multiple banners (array)
//    */
//   function injectCollectionGridBanner() {
//     // Get collection handle from Shopify page data
//     const collectionHandle = window.Shopify?.page?.collection?.handle;
//     if (!collectionHandle) return;

//     // Get banner data for this collection
//     let bannerData = window.collectionGridBannerData?.[collectionHandle];
//     if (!bannerData) return;

//     // Convert single banner object to array for consistent handling
//     const banners = Array.isArray(bannerData) ? bannerData : [bannerData];

//     // Find the Algolia hits list
//     const hitsList = document.querySelector('.ais-Hits-list');
//     if (!hitsList) return;

//     // Remove existing banners first
//     const existingBanners = hitsList.querySelectorAll('.collection_grid_banner-wrapper');
//     existingBanners.forEach(banner => banner.remove());

//     // Get all hit items
//     const hits = hitsList.querySelectorAll('.ais-Hits-item');
//     if (!hits || hits.length === 0) return;

//     // Sort banners by position (lowest first) to avoid index shifting issues
//     banners.sort((a, b) => parseInt(a.position) - parseInt(b.position));

//     // Inject each banner
//     banners.forEach((banner, index) => {
//       // Calculate position (1-based to 0-based index)
//       const position = parseInt(banner.position) - 1;

//       // Adjust position to account for already-inserted banners
//       // Each banner we've inserted before this one shifts the indices
//       const adjustedPosition = position - index;

//       if (adjustedPosition < 0 || adjustedPosition >= hits.length) return;

//       // Ensure image has protocol
//       const imageUrl = banner.image?.startsWith('//') ? 'https:' + banner.image : banner.image;

//       // Create banner HTML
//       const bannerHTML = `
//         <li class="ais-Hits-item collection_grid_banner-wrapper">
//           <div class="collection_grid_banner product-block">
//             <a ${banner.link ? `href="${banner.link}"` : ''} class="collection_grid_banner--inner">
//               ${imageUrl ? `
//                 <div class="collection_grid_banner--image">
//                   <img src="${imageUrl}" alt="${banner.imageAlt || ''}" loading="lazy">
//                 </div>
//               ` : ''}
//               ${banner.title ? `
//                 <div class="collection_grid_banner--title">${banner.title}</div>
//               ` : ''}
//               ${banner.linkText ? `
//                 <div class="collection_grid_banner--link">
//                   <div class="small-feature-link">${banner.linkText}</div>
//                 </div>
//               ` : ''}
//             </a>
//           </div>
//         </li>
//       `;

//       // Insert banner at the specified position
//       // Re-query hits excluding banners to get the current product list
//       const currentHits = hitsList.querySelectorAll('.ais-Hits-item:not(.collection_grid_banner-wrapper)');
//       const targetHit = currentHits[adjustedPosition];
//       if (targetHit) {
//         targetHit.insertAdjacentHTML('beforebegin', bannerHTML);
//       }
//     });
//   }

//   // Inject banner after Algolia renders
//   document.addEventListener('algolia.hooks.afterInstantSearchRender', function() {
//     setTimeout(injectCollectionGridBanner, 100);
//   });

//   // Retry injection with polling until hits list is found
//   function tryInjectWithRetry(maxAttempts = 20, delay = 200) {
//     let attempts = 0;

//     function attemptInject() {
//       attempts++;
//       const hitsList = document.querySelector('.ais-Hits-list');

//       if (hitsList) {
//         injectCollectionGridBanner();
//       } else if (attempts < maxAttempts) {
//         setTimeout(attemptInject, delay);
//       }
//     }

//     attemptInject();
//   }

//   // Also try on load in case Algolia already rendered
//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', function() {
//       tryInjectWithRetry();
//     });
//   } else {
//     tryInjectWithRetry();
//   }

//   /**
//    * Handle "View all" button clicks
//    * Dynamically loads all products in the collection by updating hitsPerPage
//    * Only intercepts clicks when Algolia is active; otherwise lets default navigation happen
//    */
//   document.addEventListener('click', function(e) {
//     const viewAllBtn = e.target.closest('#view-all');
//     if (viewAllBtn) {
//       const helper = window.__algoliaHelper;
//       if (!helper) {
//         // Algolia not active - let default link navigation happen (e.g., ?view=all)
//         return;
//       }

//       // Algolia is active - prevent default and handle within Algolia
//       e.preventDefault();

//       // Get total results from current search state
//       const totalResults = helper.lastResults?.nbHits || 1000;

//       // Set session flag to hide button on re-render
//       window.__algoliaViewAllActive = true;

//       // Update search to show all results
//       helper.setQueryParameter('hitsPerPage', totalResults);
//       helper.search();

//       // Hide pagination immediately (will be maintained by noResultsToggler)
//       const paginationRow = document.querySelector('.pagination-row:not(#view-all-container)');
//       const paginationElm = document.querySelector('.ais-pagination-container, .ais-Pagination');
//       if (paginationRow) paginationRow.style.display = 'none';
//       if (paginationElm) paginationElm.style.display = 'none';

//       config.log?.('View all activated:', totalResults, 'products');
//     }
//   });

//   config.log?.('Algolia InstantSearch hooks registered');
// });

/**
 * Algolia InstantSearch
 * InstantSearch hooks for main search results page
 */

/**
 * Style Algolia SearchBox - Run immediately
 * Apply theme styling to Algolia's search input
 */
(function skinAlgoliaSearchBox() {
  'use strict';

  const config = window.algoliaThemeConfig || {};

  const apply = () => {
    const input = document.querySelector('.main-search .ais-SearchBox-input');

    if (input) {
      const hasClass = input.classList.contains('main-search__input');

      if (!hasClass) {
        input.classList.add('main-search__input');
        input.setAttribute(
          'placeholder',
          input.getAttribute('placeholder') || config.text?.searchPlaceholder || 'Search...'
        );
      }
    }
  };

  // Setup observer when DOM is ready
  const setupObserver = () => {
    apply(); // Run once immediately
    if (document.body) {
      new MutationObserver(apply).observe(document.body, { childList: true, subtree: true });
    }
  };

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupObserver);
  } else {
    setupObserver();
  }
})();

document.addEventListener('algolia.hooks.initialize', function() {
  'use strict';

  const config = window.algoliaThemeConfig || {};
  const utils = window.algoliaUtils || {};
  const templates = window.algoliaTemplates || {};

  /**
   * Collection pages keep Algolia's default `collection_ids` filter.
   * Do not remap to `collections:{handle}` — Merchandising Studio Category
   * Pages use collection ID as the identifier (e.g. gifts-for-her-1 = 265258762286).
   */

  /**
   * Add custom widgets
   * These widgets control UI visibility based on search state
   * Also configure analytics tags for better tracking
   */
  window.algoliaShopify.hooks.registerHook('beforeISStartAddWidgetArray', function() {
    const widgets = [
      templates.makeNoResultsToggler?.() || {},
      // Custom widget to manage "View all" button visibility and helper reference
      {
        render({ helper }) {
          // Store helper reference globally for click handler access
          window.__algoliaHelper = helper;

          // Dynamically toggle View all button visibility based on session state
          const viewAllContainer = document.getElementById('view-all-container');
          if (viewAllContainer) {
            viewAllContainer.style.display = window.__algoliaViewAllActive ? 'none' : '';
          }
        }
      },
      // GTM connector: push Hits Viewed event on every render that has results
      {
        render({ results }) {
          if (!results || !results.hits || results.hits.length === 0) return;
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ event: 'Hits Viewed' });
        }
      }
    ];

    // Add configure widget for analytics tags
    if (window.algoliaShopify?.externals?.widgets?.configure) {
      const { configure } = window.algoliaShopify.externals.widgets;

      // Build analytics tags array
      const analyticsTags = [];

      // Determine page type
      const collection = window.Shopify?.page?.collection;
      const isSearchPage = window.location.pathname.includes('/search');

      if (collection) {
        // Collection page (PLP)
        analyticsTags.push('page:collection');
        analyticsTags.push(`collection:${collection.handle}`);
        config.log?.('Analytics tags - Collection page:', collection.handle);
      } else if (isSearchPage) {
        // Main search results page
        analyticsTags.push('page:search-results');
        config.log?.('Analytics tags - Search results page');
      } else {
        // Fallback
        analyticsTags.push('page:instantsearch');
      }

      // Add device type
      if (config.isMobile && config.isMobile()) {
        analyticsTags.push('device:mobile');
      } else if (window.matchMedia(`(max-width: ${config.breakpoints?.tablet || 1171}px)`).matches) {
        analyticsTags.push('device:tablet');
      } else {
        analyticsTags.push('device:desktop');
      }

      // Add user type (logged in vs guest)
      if (window.Shopify?.customer) {
        analyticsTags.push('user:logged-in');
      } else {
        analyticsTags.push('user:guest');
      }

      // Create configure widget with analytics tags and click analytics for GTM
      const configureOptions = {
        analyticsTags: analyticsTags,
        clickAnalytics: true,
      };

      const configureWidget = configure(configureOptions);

      widgets.push(configureWidget);

      config.log?.('Analytics tags configured:', analyticsTags);
    }

    return widgets;
  });

  /**
   * Async function to prefetch best sellers for fallback
   * Runs before InstantSearch initialization
   * Only runs on search pages, not collection pages (collections always have results)
   */
  window.algoliaShopify.hooks.registerHook('beforeInstantSearchAsyncFunction', async function() {
    // Skip prefetch on collection pages to avoid extra query
    const isCollectionPage = window.Shopify?.page?.collection?.handle;
    if (isCollectionPage) {
      config.log?.('Skipping best sellers prefetch on collection page');
      window.__isBestSellersFallback = [];
      return;
    }

    const BEST_SELLERS_COLLECTION_ID = config.collections?.bestSellers || 272070508590;
    const FALLBACK_LIMIT = config.search?.fallbackLimit || 12;

    try {
      const index = window.algoliaShopify.searchClient.initIndex('shopify_products');
      const { hits } = await index.search('', {
        hitsPerPage: FALLBACK_LIMIT,
        filters: `collection_ids:${BEST_SELLERS_COLLECTION_ID}`,
      });

      window.__isBestSellersFallback = hits || [];
      config.log?.('Best sellers prefetched:', hits.length);
    } catch (e) {
      config.error?.('Best-sellers prefetch failed:', e);
      window.__isBestSellersFallback = [];
    }
  });

  /**
   * No results template with fallback products
   * Shows best sellers when search returns no results
   */
  window.algoliaShopify.hooks.registerHook('beforeInstantSearchNoResultTemplate',
    function(_defaultTemplate, html) {
      const hits = window.__isBestSellersFallback || [];

      config.log?.('No results - showing', hits.length, 'fallback products');

      return html`
        <div class="ais-hit-empty">
          <div class="ais-hit-empty--title">
            ${window.algoliaShopify?.translations?.noResultFound || 'No results found'}
          </div>

          <div class="ais-no-results__fallback">
            <h3 class="ais-no-results__title">${config.text?.popularInBestSellers || 'Popular in Best sellers'}</h3>
            <div class="ais-hits-container ais-results-as-block">
              <div class="ais-Hits">
                <ol class="ais-Hits-list">
                  ${hits.length
                    ? hits.map((item) => html`
                        <li class="ais-Hits-item">
                          ${templates.renderProductCard?.(item, html) || ''}
                        </li>
                      `)
                    : ''}
                </ol>
              </div>
            </div>
          </div>
        </div>
      `;
    }
  );

  /**
   * Session-scoped flag to track "View all" state
   * - Set to true when user clicks "View all" button
   * - Resets to false on page refresh or navigation
   * - Used by custom widget to control button visibility
   */
  window.__algoliaViewAllActive = false;

  /**
   * Main InstantSearch page template
   * Defines the complete search results page layout
   */
  window.algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate',
    function(_default, data, html) {
      const collection = window.Shopify?.page?.collection;
      return html`
        <div class="ais-page">
          ${collection ? html`
            <div class="page-header page-header--with-upper-spacing">
              <div class="container">
                <h1 class="pagetitle h3-style">${collection.title}</h1>
              </div>
            </div>
          ` : ''}
          <div class="container" style="display: none;">
            <div class="main-search">
              <div class="main-search__container container">
                <div class="main-search__form" role="search">
                  <button class="main-search__button button notabutton" type="button" aria-label="Submit">
                    <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
                      <g transform="translate(3,3)" stroke="currentColor" stroke-width="1.5" fill="none" fill-rule="evenodd">
                        <circle cx="7.8235" cy="7.8235" r="7.8235"></circle>
                        <line x1="13.97" y1="13.97" x2="18.44" y2="18.44" stroke-linecap="square"></line>
                      </g>
                    </svg>
                  </button>
                  <div class="main-search__input-container">
                    <div class="ais-input">
                      <div class="ais-search-box-container"></div>
                      <div class="ais-input-button"><div class="ais-clear-input-icon"></div></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="ais-search-header">
            <div class="ais-facets-button-container">
              <button class="ais-facets-button toggle-btn utility-bar__item" data-toggle-filters>
                <span class="button-icon">
                  <svg width="23" height="19" viewBox="0 0 20 20" stroke-width="1.25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <line x1="1" y1="6" x2="19" y2="6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
                    <line x1="1" y1="14" x2="19" y2="14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></line>
                    <circle cx="7" cy="6" r="3" fill="none" stroke="currentColor"></circle>
                    <circle cx="13" cy="14" r="3" fill="none" stroke="currentColor"></circle>
                  </svg>
                </span>
                <span>Filter</span>
                <span class="toggle-btn__chevron ltr-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="9 18 15 12 9 6"></polyline>
                  </svg>
                </span>
              </button>
            </div>
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"><i class="fa fa-th-large"></i></span>
              <span class="ais-change-display-list"><i class="fa fa-th-list"></i></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`${window.algoliaShopify?.translations?.sortBy || 'Sort by'} <span class="ais-sort-orders-container"></span>`
                : html`${window.algoliaShopify?.translations?.sortBy || 'Sort by'} ${window.algoliaShopify?.translations?.relevance || 'Relevance'}`}
            </div>
          </div>

          <div class="ais-facets">
            <div class="ais-clear-refinements-container"></div>
            <div class="ais-current-refined-values-container"></div>
            ${window.algoliaShopify?.config?.app_blocks_dynamic_widgets_beta_enabled
              ? html`<div class="ais-dynamic-widgets-container"></div>`
              : data.facets.map(
                  (facet) => html`
                    <div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}" data-insights-attribute="${facet.name || facet.escapedName}">
                      <label for="${facet.escapedName}" class="ais-range-slider--header ais-facet--header ais-header">
                        ${facet.title}
                      </label>
                      <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}" name="dropdown" />
                      <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
                    </div>
                  `
                )}
          </div>

          <div class="ais-hits-block-custom ais-hits-block-custom--full">
            <div class="ais-block">
              <div class="ais-hits-container ais-results-as-block"></div>
            </div>
          </div>

          <div class="container pagination-row">
            <div class="ais-pagination-container"></div>
          </div>

          <!-- View all button - visibility controlled by custom widget -->
          ${collection ? html`
            <div class="container pagination-row text-center" id="view-all-container">
              <a href="#" id="view-all" class="button">
                View all
              </a>
            </div>
          ` : ''}

          ${collection && collection.description ? html`
            <div class="container ais-collection-description">
              <div class="container container--reading-width fully-spaced-row" dangerouslySetInnerHTML=${{ __html: collection.description }}></div>
            </div>
          ` : ''}
        </div>
      `;
    }
  );

  /**
   * Individual product card template for InstantSearch
   * Uses the shared template from algolia-templates.js
   */
  window.algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate',
    function(_defaultTemplate, hit, html) {
      return templates.renderProductCard?.(hit, html) || '';
    }
  );

  /**
   * Facet parameter customization
   * Customize price slider formatting
   */
  window.algoliaShopify.hooks.registerHook('beforeInstantSearchFacetParamsOptions',
    function(params, attribute, type) {
      if (String(attribute.type).toLowerCase() === 'slider' &&
          String(attribute.name).toLowerCase() === 'price') {

        const PRICE_IN_CENTS = config.search?.priceInCents || false;

        const fmt = (v) => {
          return utils.formatPrice?.(v, PRICE_IN_CENTS) || `$${v}`;
        };

        params.tooltips = { format: fmt };
        params.pips = false;

        config.log?.('Price slider configured - inCents:', PRICE_IN_CENTS);
      }

      return params;
    }
  );


  window.algoliaShopify.hooks.registerHook('beforeInstantSearchStatsTemplate',
    function(_defaultTemplate, data, html) {
      return html`
        ${data.hasOneResult &&
          html`
            <span class="ais-stats--nb-results">
              1 product
            </span>
          `}
        ${data.hasManyResults &&
          html`
            <span class="ais-stats--nb-results">
              ${algoliaShopify.helpers.formatNumber(data.nbHits)} ${' '}
              products
            </span>
          `}
      `;
  });

  /**
   * Ensure collapsed facets start with checkbox unchecked
   * Keep color, material, and price expanded by default
   */
  function collapseDefaultFacets() {
    const allCheckboxes = document.querySelectorAll('.ais-facet-dropdown-wrapper input.ais-dropdown-checkbox');

    // Facets that should stay expanded (matching the logic in the hook)
    const expandedFacets = ['meta.custom.color_filter', 'meta.custom.material_filter'];

    allCheckboxes.forEach(function(checkbox) {
      // The checkbox ID contains the facet name (possibly escaped)
      const checkboxId = checkbox.id;

      // Check if this checkbox ID matches any of the expanded facets
      // Handle both escaped and non-escaped versions
      const shouldStayExpanded = expandedFacets.some(function(facetName) {
        // Match the exact name or the escaped version (dots replaced with underscores or kept as-is)
        return checkboxId === facetName ||
               checkboxId === facetName.replace(/\./g, '_') ||
               checkboxId === facetName.replace(/\./g, '-');
      });

      // Set checkbox state: expanded facets should be checked, others unchecked
      checkbox.checked = shouldStayExpanded;

      // Update wrapper class for chevron animation
      const wrapper = checkbox.closest('.ais-facet-dropdown-wrapper');
      if (wrapper) {
        if (shouldStayExpanded) {
          wrapper.classList.add('is-expanded');
        } else {
          wrapper.classList.remove('is-expanded');
        }

        // Add change listener to toggle class when checkbox changes
        if (!checkbox.dataset.listenerAdded) {
          checkbox.dataset.listenerAdded = 'true';
          checkbox.addEventListener('change', function() {
            // Re-query wrapper to ensure it's current
            const currentWrapper = checkbox.closest('.ais-facet-dropdown-wrapper');
            if (currentWrapper) {
              if (checkbox.checked) {
                currentWrapper.classList.add('is-expanded');
              } else {
                currentWrapper.classList.remove('is-expanded');
              }
            }
          });
        }
      }
    });
  }

  // Try multiple times to catch when the DOM is ready
  setTimeout(collapseDefaultFacets, 100);
  setTimeout(collapseDefaultFacets, 500);
  setTimeout(collapseDefaultFacets, 1000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', collapseDefaultFacets);
  } else {
    collapseDefaultFacets();
  }

  document.addEventListener('algolia.hooks.afterInstantSearchRender', collapseDefaultFacets);

  /**
   * Custom filter toggle functionality
   * Toggles facets sidebar visibility
   */
  function setupCustomFilterToggle() {
    const toggleButton = document.querySelector('.ais-facets-button[data-toggle-filters]');
    const facetsPanel = document.querySelector('.ais-page .ais-facets');

    if (!toggleButton || !facetsPanel) return;

    // Remove Algolia's click handlers by cloning the button
    const newButton = toggleButton.cloneNode(true);
    toggleButton.parentNode.replaceChild(newButton, toggleButton);

    // Add our custom click handler
    newButton.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      const isOpen = facetsPanel.classList.contains('is-open');

      if (isOpen) {
        // Hide filters
        facetsPanel.classList.remove('is-open');
        newButton.classList.remove('is-active');
      } else {
        // Show filters
        facetsPanel.classList.add('is-open');
        newButton.classList.add('is-active');
      }
    });
  }

  // Initialize custom filter toggle - use longer delays to ensure Algolia is done
  setTimeout(setupCustomFilterToggle, 1000);
  setTimeout(setupCustomFilterToggle, 2000);
  document.addEventListener('algolia.hooks.afterInstantSearchRender', setupCustomFilterToggle);

  /**
   * Setup scroll buttons functionality
   * Makes page scroll buttons work on Algolia pages
   */
  function setupScrollButtons() {
    const scrollDown = document.querySelector('.button--page-scroll[data-direction="down"]');
    const scrollUp = document.querySelector('.button--page-scroll[data-direction="up"]');
    const footer = document.querySelector("#shopify-section-footer");

    // Setup scroll down button
    if (footer && scrollDown) {
      // Hide button when footer is visible
      new IntersectionObserver(function(entries) {
        if (entries[0].isIntersecting) {
          scrollDown.classList.add('hidden');
        } else {
          scrollDown.classList.remove('hidden');
        }
      }, {
        threshold: 0.1
      }).observe(footer);

      // Scroll to footer on click
      if (!scrollDown.dataset.listenerAdded) {
        scrollDown.dataset.listenerAdded = 'true';
        scrollDown.addEventListener('click', function() {
          window.scroll({top: footer.offsetTop, left: 0, behavior: 'smooth'});
        });
      }
    }

    // Setup scroll up button
    if (scrollUp && !scrollUp.dataset.listenerAdded) {
      scrollUp.dataset.listenerAdded = 'true';
      scrollUp.addEventListener('click', function() {
        window.scroll({top: 0, left: 0, behavior: 'smooth'});
      });
    }
  }

  // Initialize scroll buttons
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupScrollButtons);
  } else {
    setupScrollButtons();
  }

  /**
   * Collection Grid Banner Injection for Algolia
   * Injects banners into Algolia hits at specified positions
   * Supports both single banner (object) and multiple banners (array)
   */
  function injectCollectionGridBanner() {
    // Get collection handle from Shopify page data
    const collectionHandle = window.Shopify?.page?.collection?.handle;
    if (!collectionHandle) return;

    // Get banner data for this collection
    let bannerData = window.collectionGridBannerData?.[collectionHandle];
    if (!bannerData) return;

    // Convert single banner object to array for consistent handling
    const banners = Array.isArray(bannerData) ? bannerData : [bannerData];

    // Find the Algolia hits list
    const hitsList = document.querySelector('.ais-Hits-list');
    if (!hitsList) return;

    // Remove existing banners first
    const existingBanners = hitsList.querySelectorAll('.collection_grid_banner-wrapper');
    existingBanners.forEach(banner => banner.remove());

    // Get all hit items
    const hits = hitsList.querySelectorAll('.ais-Hits-item');
    if (!hits || hits.length === 0) return;

    // Sort banners by position (lowest first) to avoid index shifting issues
    banners.sort((a, b) => parseInt(a.position) - parseInt(b.position));

    // Inject each banner
    banners.forEach((banner, index) => {
      // Calculate position (1-based to 0-based index)
      const position = parseInt(banner.position) - 1;

      // Adjust position to account for already-inserted banners
      // Each banner we've inserted before this one shifts the indices
      const adjustedPosition = position - index;

      if (adjustedPosition < 0 || adjustedPosition >= hits.length) return;

      // Ensure image has protocol
      const imageUrl = banner.image?.startsWith('//') ? 'https:' + banner.image : banner.image;

      // Create banner HTML
      const bannerHTML = `
        <li class="ais-Hits-item collection_grid_banner-wrapper">
          <div class="collection_grid_banner product-block">
            <a ${banner.link ? `href="${banner.link}"` : ''} class="collection_grid_banner--inner">
              ${imageUrl ? `
                <div class="collection_grid_banner--image">
                  <img src="${imageUrl}" alt="${banner.imageAlt || ''}" loading="lazy">
                </div>
              ` : ''}
              ${banner.title ? `
                <div class="collection_grid_banner--title">${banner.title}</div>
              ` : ''}
              ${banner.linkText ? `
                <div class="collection_grid_banner--link">
                  <div class="small-feature-link">${banner.linkText}</div>
                </div>
              ` : ''}
            </a>
          </div>
        </li>
      `;

      // Insert banner at the specified position
      // Re-query hits excluding banners to get the current product list
      const currentHits = hitsList.querySelectorAll('.ais-Hits-item:not(.collection_grid_banner-wrapper)');
      const targetHit = currentHits[adjustedPosition];
      if (targetHit) {
        targetHit.insertAdjacentHTML('beforebegin', bannerHTML);
      }
    });
  }

  // Inject banner after Algolia renders
  document.addEventListener('algolia.hooks.afterInstantSearchRender', function() {
    setTimeout(injectCollectionGridBanner, 100);
  });

  // Retry injection with polling until hits list is found
  function tryInjectWithRetry(maxAttempts = 20, delay = 200) {
    let attempts = 0;

    function attemptInject() {
      attempts++;
      const hitsList = document.querySelector('.ais-Hits-list');

      if (hitsList) {
        injectCollectionGridBanner();
      } else if (attempts < maxAttempts) {
        setTimeout(attemptInject, delay);
      }
    }

    attemptInject();
  }

  // Also try on load in case Algolia already rendered
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      tryInjectWithRetry();
    });
  } else {
    tryInjectWithRetry();
  }

  /**
   * Handle "View all" button clicks
   * Dynamically loads all products in the collection by updating hitsPerPage
   * Only intercepts clicks when Algolia is active; otherwise lets default navigation happen
   */
  document.addEventListener('click', function(e) {
    const viewAllBtn = e.target.closest('#view-all');
    if (viewAllBtn) {
      const helper = window.__algoliaHelper;
      if (!helper) {
        // Algolia not active - let default link navigation happen (e.g., ?view=all)
        return;
      }

      // Algolia is active - prevent default and handle within Algolia
      e.preventDefault();

      // Get total results from current search state
      const totalResults = helper.lastResults?.nbHits || 1000;

      // Set session flag to hide button on re-render
      window.__algoliaViewAllActive = true;

      // Update search to show all results
      helper.setQueryParameter('hitsPerPage', totalResults);
      helper.search();

      // Hide pagination immediately (will be maintained by noResultsToggler)
      const paginationRow = document.querySelector('.pagination-row:not(#view-all-container)');
      const paginationElm = document.querySelector('.ais-pagination-container, .ais-Pagination');
      if (paginationRow) paginationRow.style.display = 'none';
      if (paginationElm) paginationElm.style.display = 'none';

      config.log?.('View all activated:', totalResults, 'products');
    }
  });

  config.log?.('Algolia InstantSearch hooks registered');
});
